import { makeStyles } from "tss-react/mui";
import { mdiClose } from "@mdi/js";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { MiChip } from "../MiChip/MiChip";
import { MiIcon } from "../MiIcon/MiIcon";

// TODO: Update MiInputSelectBox to be able to extends it from MiInputMultiSelectBox
function SelectInput({
  labelText,
  menuItems = [],
  value,
  error,
  handleChange,
  disabled,
  disableNone,
  ...rest
}) {
  return (
    <FormControl fullWidth error={!!error} size="small">
      <InputLabel id="select-label" shrink>
        {labelText}
      </InputLabel>
      <Select
        labelId="select-label"
        disabled={disabled}
        label={labelText}
        value={value}
        onChange={handleChange}
        inputProps={{ "data-testid": `mi-selectbox-${labelText}` }}
        notched
        {...rest}
      >
        {!disableNone && (
          <MenuItem value="None" data-testid="disable-none">
            None
          </MenuItem>
        )}
        {menuItems?.length > 0 &&
          menuItems.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.label}
            </MenuItem>
          ))}
      </Select>
      <FormHelperText>{error ? error.message : ""}</FormHelperText>
    </FormControl>
  );
}

export function MiInputMultiSelectBox({
  multiple = true,
  value = [],
  readOnly,
  menuItems = [],
  handleChange,
  name,
  labelText,
  control,
  rules,
  style,
  error,
  ...rest
}) {
  const useStyles = makeStyles()((theme) => ({
    chiplabel: {
      borderRadius: 3,
      height: 20,
      fontWeight: theme.fontWeight.medium,
      fontSize: theme.fontSize.xsmall,
      color: theme.palette.bluegrey.dark,
      backgroundColor: theme.palette.primary.light,
    },
    icon: {
      color: theme.palette.grey.main,
      cursor: "pointer",
    },
  }));

  const { classes } = useStyles();
  const handleClearClick = (e) => {
    e.stopPropagation();
    handleChange({ target: { value: [] } });
  };

  const getSelectedLabels = (selectedValues) => {
    const selectedLabels = [];
    if (menuItems?.length) {
      menuItems?.forEach((item) => {
        // If the item is a group, then we need to iterate over the menuItems of the group
        if (item.type === "group") {
          item.menuItems.forEach((subItem) => {
            if (selectedValues.includes(subItem.value)) {
              selectedLabels.push(subItem);
            }
          });
        } else if (selectedValues.includes(item.value)) {
          selectedLabels.push(item);
        }
      });
    }
    return selectedLabels;
  };

  const getSelectedChips = () => {
    const arr = getSelectedLabels(value);
    return (
      <div
        style={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          ...rest?.chipsStyle,
        }}
      >
        {arr.map((option) => (
          <div key={option.id || option.value}>
            <MiChip label={option.label} className={classes.chiplabel} />
            {!!option.secondaryInfo && (
              <div>
                <i>Pay Date: </i>
                {option.secondaryInfo}
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  return (
    <SelectInput
      menuItems={menuItems}
      renderValue={getSelectedChips}
      multiple={multiple}
      value={value?.length ? value : []}
      handleChange={handleChange}
      fullWidth
      sx={{
        "& .MuiSelect-iconStandard": { display: value?.length ? "none" : "" },
        ...rest.sx,
      }}
      endAdornment={
        value?.length && !readOnly && !rest.disabled ? (
          <MiIcon
            onClick={handleClearClick}
            path={mdiClose}
            style={{ marginRight: 20, ...rest.endAdornmentStyle }}
            className={classes.icon}
          />
        ) : null
      }
      labelText={labelText}
      {...rest}
      error={error}
      data-testid={`mi-multiselectbox-${labelText}`}
    />
  );
}
